import {
  AfterViewInit,
  Component,
  ElementRef,
  OnInit,
  ViewChild,
} from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { ActivatedRoute } from "@angular/router";
import { jqxListBoxComponent } from "jqwidgets-ng/jqxlistbox";
import { ToastrService } from "ngx-toastr";
import { AnoEscolaridade } from "../models/ano-escolaridade.model";
import { AreaConhecimento } from "../models/area-conhecimento.model";
import { ComponenteCurricular } from "../models/componente-curricular.model";
import { Habilidade } from "../models/habilidate.model";
import { Questao } from "../models/questao.model";
import { Segmento } from "../models/segmento.model";
import { QuestaoService } from "../services/questao.service";

@Component({
  selector: "app-edicao",
  templateUrl: "./editar.component.html",
})
export class EditarComponent implements AfterViewInit {
  @ViewChild("habilidadesListBox", { static: false })
  habilidadesListBox: jqxListBoxComponent;
  @ViewChild("ContentPanel", { static: false }) ContentPanel: ElementRef;
  @ViewChild("areasConhecimentoListBox", { static: false })
  areasConhecimentoListBox: jqxListBoxComponent;
  @ViewChild("componentesCurricularesListBox", { static: false })
  componentesCurricularesListBox: jqxListBoxComponent;
  @ViewChild("segmentosListBox", { static: false })
  segmentosListBox: jqxListBoxComponent;
  @ViewChild("anosEscolaridadeListBox", { static: false })
  anosEscolaridadeListBox: jqxListBoxComponent;
  questao: Questao;
  editarQuestaoForm: FormGroup;
  disabled: boolean = true;
  porCodigo: boolean = false;
  textoPesquisaHabilidade: string;
  habilidades: Habilidade[] = [];
  areasConhecimento: AreaConhecimento[] = [];
  componentesCurriculares: ComponenteCurricular[] = [];
  segmentos: Segmento[] = [];
  anosEscolaridade: AnoEscolaridade[] = [];
  //#region habilidadesListBox
  habilidadesListBoxOptions: jqwidgets.ListBoxOptions = {
    displayMember: "codigo",
    valueMember: "id",
    multiple: false,
    width: 200,
    filterable: false,
    itemHeight: 30,
    theme: "fresh"
  };
  //#endregion
  //#region Areas Conhecimento
  areasConhecimentoListBoxOptions: jqwidgets.ListBoxOptions = {
    displayMember: "nome",
    valueMember: "id",
    multiple: false,
    width: 500,
    filterable: false,
    itemHeight: 30,
    theme: "fresh"
  };
  componenteCurricularListBoxOptions: jqwidgets.ListBoxOptions = {
    displayMember: "nome",
    valueMember: "id",
    multiple: false,
    width: 400,
    filterable: false,
    // searchMode: "containsignorecase",
    //filterPlaceHolder: "buscar pela descricao",
    itemHeight: 30,
    theme: "fresh"
  };
  //#endregion
  //#region Segmentos
  //anosEscolaridadeListBoxOptions
  segmentosListBoxOptions: jqwidgets.ListBoxOptions = {
    displayMember: "nome",
    valueMember: "id",
    multiple: false,
    width: 400,
    filterable: false,
    itemHeight: 30,
    theme: "fresh"
  };
  anosEscolaridadeListBoxOptions: jqwidgets.ListBoxOptions = {
    displayMember: "nome",
    valueMember: "id",
    multiple: false,
    width: 400,
    filterable: false,
    itemHeight: 30,
    theme: "fresh"
  };
  //#endregion
  /**
   *
   */
  constructor(
    private questaoService: QuestaoService,
    private toastr: ToastrService,
    private route: ActivatedRoute,
   
    private fb: FormBuilder,
    private toastrService:ToastrService
  ) {
    let questaoId = route.snapshot.params.id;

    questaoService.obterQuestaoPorId(questaoId).subscribe((response) => {
      this.questao = response.data;
      this.editarQuestaoFormConfig(this.questao);
    });
    questaoService.obterAreasConhecimentoSegmentos().subscribe((response) => {
      this.areasConhecimento = response.data.areasConhecimento;
      this.areasConhecimentoListBoxOptions.source = this.areasConhecimento;

      this.segmentos = response.data.segmentos;
      this.segmentosListBoxOptions.source = this.segmentos;

      if (this.questao?.anoEscolaridadeId != null) {
        let segmentoIndex = this.segmentos.findIndex(
          (element) => element.id == this.questao.anoEscolaridade.segmentoId
        );
        this.segmentosListBoxOptions.selectedIndex = segmentoIndex;

        let segmento = this.segmentos[segmentoIndex];
        this.anosEscolaridade = segmento.anosEscolaridade;
        this.anosEscolaridadeListBoxOptions.source = this.anosEscolaridade;
        let anoEscolaridadeIndex = this.anosEscolaridade.findIndex(
          (element) => element.id == this.questao.anoEscolaridadeId
        );
        this.anosEscolaridadeListBoxOptions.selectedIndex =
          anoEscolaridadeIndex;
        this.anosEscolaridadeListBox.setOptions(
          this.anosEscolaridadeListBoxOptions
        );
        ////////////////////////////////////////////////////////////////////////
        let areaConhecimentoIndex = this.areasConhecimento.findIndex(
          (element) =>
            element.id == this.questao.componenteCurricular.areaConhecimentoId
        );
        this.areasConhecimentoListBoxOptions.selectedIndex =
          areaConhecimentoIndex;

        let areaConhecimento = this.areasConhecimento[areaConhecimentoIndex];
        this.componentesCurriculares = areaConhecimento.componentesCurriculares;
        this.componenteCurricularListBoxOptions.source =
          this.componentesCurriculares;
        let componenteCurricularIndex = this.componentesCurriculares.findIndex(
          (element) => element.id == this.questao.componenteCurricularId
        );
        this.componenteCurricularListBoxOptions.selectedIndex =
          componenteCurricularIndex;
        this.componentesCurricularesListBox.setOptions(
          this.componenteCurricularListBoxOptions
        );
      }

      this.areasConhecimentoListBox.setOptions(
        this.areasConhecimentoListBoxOptions
      );
      this.segmentosListBox.setOptions(this.segmentosListBoxOptions);
    });
    this.editarQuestaoFormConfig(null);
  }
  ngAfterViewInit(): void {
    this.habilidadesListBox.setOptions(this.habilidadesListBoxOptions);
    this.segmentosListBox.setOptions(this.segmentosListBoxOptions);
    this.anosEscolaridadeListBox.setOptions(
      this.anosEscolaridadeListBoxOptions
    );
    this.areasConhecimentoListBox.setOptions(
      this.areasConhecimentoListBoxOptions
    );
    this.componentesCurricularesListBox.setOptions(
      this.componenteCurricularListBoxOptions
    );
  }

  editarQuestaoFormConfig(questao: Questao) {
    this.editarQuestaoForm = this.fb.group({
      titulo: [questao?.titulo],
      texto: [questao?.texto],
      explicacaoProfessor: [questao?.explicacaoProfessor],
      active:[questao?.active]
     
    });
    if (this.questao?.anoEscolaridadeId != null && this.questao?.habilidadeId != null) {
      this.ContentPanel.nativeElement.innerHTML = null;
      this.questaoService
        .obterHAbilidades(true, this.questao.habilidade.codigo)
        .subscribe((response) => {
          this.habilidades = response.data;
          this.habilidadesListBoxOptions.source = response.data;
          this.habilidadesListBoxOptions.selectedIndex = 0;
          this.habilidadesListBox.setOptions(this.habilidadesListBoxOptions);
        });    
    }
  }

  pesquisarHabilidade() {
    this.ContentPanel.nativeElement.innerHTML = null;
    this.questaoService
      .obterHAbilidades(this.porCodigo, this.textoPesquisaHabilidade)
      .subscribe((response) => {
        this.habilidades = response.data;
        this.habilidadesListBoxOptions.source = response.data;
        this.habilidadesListBox.setOptions(this.habilidadesListBoxOptions);
      });
  }
  atualizarPainel(index): void {
    let container = document.createElement("div");
    container.style.margin = "5px";
    let leftColumn = document.createElement("div");
    leftColumn.style.cssText = "float: left; width:100%";   
    container.appendChild(leftColumn);   
    let datarecord = this.habilidades[index];
    let firstname =
      '<div style="margin: 10px;"><b>Codigo:</b> ' +
      datarecord.codigo +
      "</div>";
    let lastname =
      '<div style="margin: 10px;"><b>Descrição:</b> ' +
      datarecord.descricao +
      "</div>";
    leftColumn.innerHTML += firstname;
    leftColumn.innerHTML += lastname;
    this.ContentPanel.nativeElement.innerHTML = container.innerHTML;
  }

  selecionarHabilidade(event: any): void {
   
    this.atualizarPainel(event.args.index);
   
    this.questao.habilidadeId = this.habilidades[event.args.index].id;
  }
  selecionarSegmento(event: any): void {
    let segmento = this.segmentos[event.args.index];
    this.anosEscolaridade = segmento.anosEscolaridade;
    this.anosEscolaridadeListBoxOptions.source = this.anosEscolaridade;
    this.anosEscolaridadeListBox.setOptions(
      this.anosEscolaridadeListBoxOptions
    );
  }
  selecionarAnoEscolaridade(event: any) {
    this.questao.anoEscolaridadeId = this.anosEscolaridade[event.args.index].id;
  }
  selecionarAreaConhecimento(event: any): void {
    let areaConhecimento = this.areasConhecimento[event.args.index];
    this.componentesCurriculares = areaConhecimento.componentesCurriculares;
    this.componenteCurricularListBoxOptions.source =
      this.componentesCurriculares;
    this.componentesCurricularesListBox.setOptions(
      this.componenteCurricularListBoxOptions
    );
  }
  selecionarComponenteCurricular(event: any) {
    this.questao.componenteCurricularId =
      this.componentesCurriculares[event.args.index].id;
  }

  editarQuestao() {
    this.questao.anoEscolaridade = null;
    this.questao.componenteCurricular = null;
    this.questao.habilidade = null;

    this.questao= Object.assign({},this.questao,this.editarQuestaoForm.value);

    this.questaoService.atualizarQuestao(this.questao).subscribe((response) => {
      if(response.success){
        this.questao = response.data;
        this.editarQuestaoFormConfig(this.questao);
        let toastr = this.toastrService.success('Questão atualizada!', 'Sucesso');
      }
      else{
        response.errors.forEach(error => {
          let toastr = this.toastrService.error(error, 'Erro');
        });
      }
    });  }
}
